import { render, staticRenderFns } from "./modal-pedido.vue?vue&type=template&id=569ffa03&"
import script from "./modal-pedido.vue?vue&type=script&lang=js&"
export * from "./modal-pedido.vue?vue&type=script&lang=js&"
import style0 from "./modal-pedido.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports